(function() {
    angular.module('wizard')
    .controller('WizardButtonComponentController', ['$log', '$scope','$rootScope', 'Storage','PagamentosService','SessionData', function($log, $scope, $rootScope, Storage, PagamentosService,SessionData) {
        let vm = this;
        let aluno = SessionData.aluno.list[0];

        vm.permitePagamentoExterno = false;

        let parametros = {
            codAluno: aluno.codAluno,
            listaDeCobrancas: null
        }

        PagamentosService.obterConfiguracoesPagamentoExterno(parametros).then(function (configPgtoExterno){
            if(configPgtoExterno !== null && configPgtoExterno !== undefined){
                configPgtoExterno.map(function(configuracao){
                    if(configuracao.conector === 'FlyWire'){
                        vm.permitePagamentoExterno = true;
                        vm.nomeConector = configuracao.conector
                        Storage.set('configPgtoExterno', configuracao);
                    }
                });
            }
        });

        vm.buttonsClass = function() {
            if(vm.getWindowWidth() >= 460) {
                if(vm.fixButton)
                    return 'wizard-buttons-all-fixed';
                //return 'wizard-buttons-all';
                return 'container-fluid';
            } else {
                if(vm.fixButton)
                    return 'wizard-buttons-phone-fixed';
                //return 'wizard-buttons-phone';
                return 'container-fluid';
            }
        }

        vm.cancelClass = function() {
            return 'button '+ vm.cancelButton.style +' button-break-line w-28';
        }
        vm.nextClass = function(firstStep) {
            if(vm.cancelButton && vm.cancelButton.enabled && !firstStep)
                return 'button '+ vm.nextButton.style +' button-break-line w-62 ';
            return 'button '+ vm.nextButton.style +' button-break-line w-90';
        }
        vm.finalClass = function() {
            if(vm.cancelButton && vm.cancelButton.enabled)
                return 'button '+ vm.finalButton.style +' button-break-line w-62';
            return 'button '+ vm.finalButton.style +' button-break-line w-90 ';
        }
        
        $scope.onPaymentClick = function(){
          $rootScope.$broadcast('onPaymentClickBroadcast');
        }

        $scope.onPixPaymentClick = function(){
            $rootScope.$broadcast('onPixPaymentClickBroadcast');
        }

        $scope.onPagamentoExternoClick = function(){
            $rootScope.$broadcast('onPagamentoExternoClickBroadcast');
        }
        
        vm.getWindowWidth = function() {
            return window.innerWidth;
        }
	}]);
})();
